import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { config } from './config';

// Initialize HyperDX for observability (session replay, traces, logs)
// This must happen before React renders to capture all events
if (config.HYPERDX_API_KEY && config.HYPERDX_URL) {
  import('@hyperdx/browser').then((HyperDX) => {
    HyperDX.default.init({
      // Self-hosted ClickStack endpoint (required for self-hosted)
      url: config.HYPERDX_URL,
      apiKey: config.HYPERDX_API_KEY,
      service: config.HYPERDX_SERVICE,
      // Privacy-first: mask all input values by default
      maskAllInputs: true,
      maskAllText: false,
      // Propagate traces to backend API for end-to-end correlation
      tracePropagationTargets: [
        /goodoutcomes\.io/,      // Production/staging API
        /goodoutcomes\.ai/,      // Alternative domain
        /localhost:8000/,        // Local development
      ],
      // Enable console and network capture for debugging
      consoleCapture: true,
      advancedNetworkCapture: true,
    });

    if (config.ENVIRONMENT === 'development') {
      console.log('HyperDX initialized for observability:', {
        url: config.HYPERDX_URL,
        service: config.HYPERDX_SERVICE,
      });
    }
  }).catch((err) => {
    console.warn('Failed to initialize HyperDX:', err);
  });
} else if (config.ENVIRONMENT === 'development') {
  console.log('HyperDX disabled (missing API key or URL)', {
    hasApiKey: !!config.HYPERDX_API_KEY,
    hasUrl: !!config.HYPERDX_URL,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
